<div class="panel-options-footer">
    <button type="button" class="btn btn-default mr-10" (click)="cancelEvent.emit()">{{ "cancel" | translate }}</button>
    <button
        type="button"
        class="btn btn-success"
        [class.disabled]="isSaveDisabled"
        (click)="!isSaveDisabled && saveEvent.emit()"
    >
        {{ "save" | translate }}
    </button>
</div>
